export default function() {
    const imageComponents = document.querySelectorAll('.c-media');
    const imageStackComponents = document.querySelectorAll('.c-imagestack');
    const tableComponents = document.querySelectorAll('table');

    for (var i = 0, len = imageComponents.length; i < len; i++) {
        imageComponents[i].parentNode.classList.add('col-image');
        imageComponents[i].parentNode.parentNode.classList.add('row-image');
    }

    for (var i2 = 0, len2 = imageStackComponents.length; i2 < len2; i2++) {
        imageStackComponents[i2].parentNode.classList.add('col-image', 'col-imagestack');
        imageStackComponents[i2].parentNode.parentNode.classList.add('row-image', 'row-imagestack');

        imageStackComponents[i2].addEventListener('click', function(event) {
            event.preventDefault();
            if (this.classList.contains('showsecond')) {
                this.classList.remove('showsecond');
                this.classList.add('showfirst');
            } else {
                this.classList.remove('showfirst');
                this.classList.add('showsecond');
            }
        });
    }

    for (var i3 = 0, len3 = tableComponents.length; i3 < len3; i3++) {
        tableComponents[i3].parentNode.parentNode.classList.add('c-table');
    }
}
